import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../../Molecules';

import styles from './TTSQuestionPanel.module.css';

type TTSQuestionPanelProps = {
  instruction: string;
  onPressClose: () => void;
};

export const TTSQuestionPanel = (props: TTSQuestionPanelProps) => {
  const { instruction, onPressClose } = props;
  return (
    <div className={styles.questionContainer}>
      {/* <TTSPlayer /> */}

      <p className={styles.questionText}>{instruction}</p>

      <div className={styles.expandQuestionButton} onClick={onPressClose}>
        <SvgIcon
          name={SVGIconType.Arrow}
          width={20}
          height={20}
          stroke="#808080"
        />
      </div>
    </div>
  );
};
